import styled from 'styled-components';

export const Container = styled.section`
	position: fixed;
	left: 0;
	top: 0;
	width: 150px;
	height: 100vh;
	padding: 20px;
	background: transparent;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.5s ease;

	${(props) =>
		!props.isNavbarOpen &&
		`
        height: 150px;
        overflow: hidden;
    `}
`;

export const ContainerInner = styled.section`
	width: 100%;
	height: 100%;
	background: var(--black);
	box-shadow: var(--box-shadow);
	border-radius: 30px;
	padding: 40px 20px;
	overflow-x: hidden;
	overflow-y: scroll;
	-ms-overflow-style: none;
	scrollbar-width: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	transition: all 0.5s ease;

	&::-webkit-scrollbar {
		display: none;
	}

	${(props) =>
		!props.isNavbarOpen &&
		`
            box-shadow: var(--box-shadow-light);
        `}
`;

export const LogoContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 1;
	visibility: visible;
	transition: all 0.5s ease;

	${(props) =>
		!props.isNavbarOpen &&
		`
            opacity: 0;
            visibility: hidden;
        `}
`;

export const LogoImg = styled.img`
	width: 100%;
`;

export const LinkContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	opacity: 1;
	visibility: visible;
	transition: all 0.5s ease;

	${(props) =>
		!props.isNavbarOpen &&
		`
            opacity: 0;
            visibility: hidden;
        `}
`;

export const Link = styled.a`
	width: 50px;
	height: 50px;
	font-size: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 15px 0;
	color: white;
	border-radius: 10px;
	background: transparent;
	transition: background 0.5s ease;

	&:hover {
		background: var(--black-dark);
	}

	&.currentPageLink {
		background: var(--gradient);

		&:hover {
			background: var(--gradient);
		}
	}
`;

export const ButtonContainer = styled.div`
	position: relative;
	left: 50%;
	transform: translate(-50%, 0);
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.5s ease;

	${(props) =>
		!props.isNavbarOpen &&
		`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        `};
`;

export const Button = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 50px;
	font-size: 20px;
	color: white;
	background: var(--gradient);
	border-radius: 50%;
	border: none;
	cursor: pointer;
`;
